import { Link } from 'react-router-dom';
import {
  Container, Grid, Card, CardContent, CardActionArea, Typography, Box, Paper
} from '@mui/material';
import {
  Login as LoginIcon,
  Dashboard as DashboardIcon,
  Payment as PaymentIcon,
  History as HistoryIcon,
  AccountBalance as AccountBalanceIcon,
  Send as SendIcon
} from '@mui/icons-material';

const PageHub = () => {
  const pages = [
    {
      name: 'Login',
      path: '/',
      icon: <LoginIcon />,
      color: '#2196f3',
      description: 'Staff login page'
    },
    {
      name: 'Dashboard',
      path: '/Dashboard',
      icon: <DashboardIcon />,
      color: '#4caf50',
      description: 'Main dashboard with stats and quick actions'
    },
    {
      name: 'Add Collection',
      path: '/AddCollection',
      icon: <PaymentIcon />,
      color: '#ff9800',
      description: 'Search customer and add collection payment'
    },
    {
      name: 'View History',
      path: '/ViewHistory',
      icon: <HistoryIcon />,
      color: '#9c27b0',
      description: 'View collected payment details with filters'
    },
    {
      name: 'Cash Book',
      path: '/CashBook',
      icon: <AccountBalanceIcon />,
      color: '#f44336',
      description: 'View cash denominations and balance'
    },
    {
      name: 'Cash Management',
      path: '/CashManagement',
      icon: <SendIcon />,
      color: '#00bcd4',
      description: 'Submit daily collection to branch/bank'
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, mb: 4, textAlign: 'center', bgcolor: 'primary.main', color: 'white' }}>
        <Typography variant="h3" gutterBottom>
          Collection App - Testing Hub
        </Typography>
        <Typography variant="subtitle1">
          Click on any card to navigate to that page
        </Typography>
      </Paper>

      <Grid container spacing={3}>
        {pages.map((page) => (
          <Grid item xs={12} sm={6} md={4} key={page.path}>
            <Link to={page.path} style={{ textDecoration: 'none' }}>
              <Card sx={{ height: '100%', '&:hover': { boxShadow: 6 } }}>
                <CardActionArea sx={{ height: '100%' }}>
                  <CardContent sx={{ textAlign: 'center', p: 3 }}>
                    <Box
                      sx={{
                        fontSize: 60,
                        color: page.color,
                        mb: 2
                      }}
                    >
                      {page.icon}
                    </Box>
                    <Typography variant="h5" gutterBottom>
                      {page.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {page.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Link>
          </Grid>
        ))}
      </Grid>

      <Paper elevation={2} sx={{ p: 3, mt: 4, bgcolor: '#f5f5f5' }}>
        <Typography variant="h6" gutterBottom>
          Navigation Guide:
        </Typography>
        <Typography variant="body2" component="div">
          <ul>
            <li><strong>Login:</strong> Staff authentication page</li>
            <li><strong>Dashboard:</strong> Overview with statistics and quick action tiles</li>
            <li><strong>Add Collection:</strong> Search customers and record payment collections</li>
            <li><strong>View History:</strong> View and filter all collected payments</li>
            <li><strong>Cash Book:</strong> Count cash denominations and view balance</li>
            <li><strong>Cash Management:</strong> Submit collections to branch or deposit to bank</li>
          </ul>
        </Typography>
      </Paper>
    </Container>
  );
};

export default PageHub;
